<template>
<v-container fluid class="pb-10">
  <!--<v-row justify="center" align="center">
    <v-col>
      <v-img width="400" contain src="@/assets/client/Group1.svg"/>
    </v-col>
    <v-col>
      <v-img width="400" contain src="@/assets/client/Group2.svg"/>
    </v-col>
    <v-col>
      <v-img width="400" contain src="@/assets/client/Group3.svg"/>
    </v-col>
  </v-row>
  <v-row justify="center" align="center">
    <v-col>
      <v-img width="400" contain src="@/assets/client/Group4.svg"/>
    </v-col>
    <v-col>
      <v-img width="400" contain src="@/assets/client/Group5.svg"/>
    </v-col>
    <v-col>
      <v-img width="400" contain src="@/assets/client/Group6.svg"/>
    </v-col>
  </v-row>-->
  <v-row justify="center" align="center">
    <v-col>
      <v-img width="400" contain src="@/assets/client/Group7.svg"/>
    </v-col>
    <v-col>
      <v-img width="400" contain src="@/assets/client/Group8.svg"/>
    </v-col>
    <v-col>
      <v-img width="400" contain src="@/assets/client/Group9.svg"/>
    </v-col>
  </v-row>
</v-container>
</template>
<script>
export default {
    name: "WhatClientThink",
    data(){
        return{              
        }
    }
}
</script>
<style scoped>
div{
    font-family: AvenirMedium;
}
@media only screen and (max-width: 1350px){
  #card{
    max-width: 338px;
  }
}
@media only screen and (max-width: 500px){
  #card{
    max-width: 190px;
  }
  p{
    text-align: justify;
    margin-left: 0.3cm;
    margin-right: 0.3cm;
  }
}
</style>